import { useBatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore/BatchSkiptraceStoreLive'

export const useBatchSkiptraceProgress = () =>
  useBatchSkiptraceStore(store => store.progress.state)
